import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { CircularProgress } from "@mui/material";
import { cloneElement } from "react";
export const WithLoading = ({ children, loading = false, position = "left", text = "loading", }) => {
    return loading
        ? cloneElement(children, {
            disabled: loading,
            startIcon: position === "left" && text && text.length > 0 ? (_jsx(CircularProgress, { color: "inherit", size: 18, thickness: 4 })) : null,
            endIcon: position === "right" && text && text.length > 0 ? (_jsx(CircularProgress, { color: "inherit", size: 18, thickness: 4 })) : null,
            children: text && text.length > 0 ? (text) : (_jsx(CircularProgress, { color: "inherit", size: 18, thickness: 4 })),
        })
        : children;
};
//# sourceMappingURL=WithLoading.js.map